import { useSelector } from 'react-redux';
import { selectSuggestions } from '@client/catalog/redux/suggestions/redux';
import { RemoteRecord } from '@client/common/redux/RemoteRecord';
import { SuggestionsType } from 'b2b-common/core/catalog/Suggestions.types';

export function useSuggestionsData(): RemoteRecord<SuggestionsType> {
  return useSelector(selectSuggestions);
}
